@if (vm$ | async; as vm) {
  @if ((vm.enableRecording$ | async) === false) {
    <div class="video-player-controls">
      <div class="video-player-controls__control-buttons">
        <ng-container>
          @if ((vm.recordingState$ | async) === 'recording' || (vm.recordingState$ | async) === 'paused') {
            <jui-icon
              size="xl"
              color="danger"
              id="stop"
              name="stop"
              (click)="stop()"
              [attr.data-qa]="'videoStop'"
              >
            </jui-icon>
          }
          @if ((vm.recordingState$ | async) === 'recording') {
            <jui-icon
              size="xl"
              color="low"
              id="pause"
              name="pause"
              (click)="pause()"
              [attr.data-qa]="'videoPause'"
              >
            </jui-icon>
          }
          @if ((vm.recordingState$ | async) === 'paused') {
            <jui-icon
              size="xl"
              color="danger"
              id="resume"
              name="pause"
              (click)="resume()"
              [attr.data-qa]="'videoResume'"
              >
            </jui-icon>
          }
          <question-video-player-timer
            class="video-player-controls__control-buttons--timer"
            [recordingState]="vm.recordingState$"
            [timeLimit]="60"
            (timerFinished)="stop()"
          ></question-video-player-timer>
          @if ((vm.enableDeletion$ | async) === true) {
            <jui-icon
              class="video-player-controls__control-buttons--delete"
              size="xl"
              color="danger"
              id="idle"
              name="delete_outline"
              (click)="remove()"
              [attr.data-qa]="'videoRemove'"
              >
            </jui-icon>
          }
        </ng-container>
      </div>
    </div>
  }
  @if ((vm.enableRecording$ | async) === true) {
    <div class="video-player-empty">
      <jui-button size="md" color="primary" id="start" (click)="start()" [attr.data-qa]="'videoStart'">
        <span slot="icon" class="material-icons">video_call</span>
        {{ vm.translations.startRecording }}
      </jui-button>
    </div>
  }
}
